import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const HomePartner = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          partnersNameOne
          partnersNameTwo
          partnersOneContent
          partnersTwoContent
          partnersTopTitle
          partnersTitle
          partLogoOne {
            localFile {
              childrenImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  width: 100
                  placeholder: DOMINANT_COLOR
                  quality: 80
                )
              }
            }
          }
          partLogoTwo {
            localFile {
              childrenImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  width: 100
                  placeholder: DOMINANT_COLOR
                  quality: 80
                )
              }
            }
          }
        }
      }
    }
  `)

  const {
    partnersNameOne,
    partnersNameTwo,
    partnersOneContent,
    partnersTwoContent,
    partnersTopTitle,
    partnersTitle,
  } = data.wpContentSettings?.home

  const logoOne =
    data.wpContentSettings?.home?.partLogoOne?.localFile?.childrenImageSharp[0]
      .gatsbyImageData
  const logoTwo =
    data.wpContentSettings?.home?.partLogoTwo?.localFile?.childrenImageSharp[0]
      .gatsbyImageData

  const altOne = data.wpContentSettings?.home?.partLogoOne?.altText || `logo`
  const altTwo = data.wpContentSettings?.home?.partLogoTwo?.altText || `logo`

  return (
    <>
      <div className="row">
        <div className="col-lg-10 col-xl-10 col-xxl-8 mx-auto text-center">
          <h2 className="fs-17 text-uppercase text-muted mb-3">
            {partnersTopTitle}
          </h2>
          <h3 className="display-4 mb-9">{partnersTitle}</h3>
        </div>
      </div>

      <div className="row gx-14 justify-content-center">
        <div className="col-lg-5 d-flex flex-column align-items-center">
          <h3 className="fs-17 text-uppercase text-muted mb-6">
            {partnersNameOne}
          </h3>

          <GatsbyImage
            image={logoOne}
            alt={altOne}
            className="d-flex w-80"
            style={{ width: "85%" }}
          />
          <p className="mt-5 text-center">{partnersOneContent}</p>
        </div>
        <div className="col-lg-5 d-flex flex-column align-items-center">
          <h3 className="fs-17 text-uppercase text-muted mb-6">
            {partnersNameTwo}
          </h3>
          <GatsbyImage
            image={logoTwo}
            alt={altTwo}
            className="d-flex"
            style={{ width: "100%" }}
          />

          <p className="mt-5 text-center"> {partnersTwoContent}</p>
        </div>
      </div>
    </>
  )
}

export default HomePartner
